module.exports = {
      id: "personas:two-usage",
      viewBox: "0 0 32 43",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#personas:two-usage",
      toString: function () {
        return this.url;
      }
    }